<!--
example
<RadioGroup v-model="a" data=[
  {text:'选项1',value:'1',disabled:true}
]></RadioGroup>
-->
<template>
	<div class="radio-group">
		<!-- <Radio v-for="(item,index) in data" :key="index" v-model="groupValue" :value="item.value"
			   :disabled="item.disabled">{{item.text}}
		</Radio> -->
		<Radio class="mr1x mb1x" :class='{disable:item.disabled}' v-for="(item,index) in data" :key="index" v-model="groupValue" :label="item.value"	:text='item.text'></Radio>
	</div>
</template>
<script>
import Radio from './Radio'
//import MyRadio from "@/components/common/ui/MyRadio";
export default {
	name: 'radioGroup',
	data(){
		return {
			groupValue: this.value
		}
	},
	watch: {
		groupValue(v){
			this.$emit('input', v);
			this.change ? this.change(v) : ''
		},
		value(v){
			this.groupValue = v;
		}
	},
	props: {
		value: {},
		modelValue: {},
		data: Array,
		change: Function
	},
	components: {Radio},
	methods: {},
	mounted(){
	},
	computed: {}
}
</script>
<style lang="scss" scoped>
.dsP{
	display: block
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/RadioGroup.vue